/* Guard Depot — Shopify cart adapter (shop), Release 2.
   Listens for gd:checkout (detail from #gdn-start data-*: tabletop, rack, level, ap, switches, failover, agreed).
   Gate lives in gd-home.js; cart re-checks (>=1 Firebox + level + agreed) and guards double fires (4s).
   For each equipment qty>0: rental variant x qty + managed variant[level] x qty. failover: rental + 4G/5G data (flat).
   Opens the GIX_CART drawer. Also relays c3q:lead -> POST /contact. */
(function(){
  "use strict";
  var RENT={ tabletop:"51291642659063", rack:"51291642691831", ap:"51291642724599", sw:"51291642757367", fo:"51291642790135" };
  var MGD={
    tabletop:{ b:"51291642822903", p:"51291642855671", x:"51291642888439" },
    rack:{ b:"51291642921207", p:"51291642953975", x:"51291642986743" },
    ap:{ b:"51291643019511", p:"51291643052279", x:"51291643085047" },
    sw:{ b:"51291643117815", p:"51291643150583", x:"51291643183351" }
  };
  var FDATA="51291643216119";
  var cart={items:[],item_count:0};
  function money(c){ return (c||0)/100; }
  function openDrawer(){ var d=document.querySelector("[data-gix-cart]"); if(d) d.classList.add("gcart--open"); }
  function syncBadge(){ var q=cart.item_count||0;
    document.querySelectorAll(".dcart__count").forEach(function(el){el.textContent=q;});
    document.querySelectorAll(".mcart .c").forEach(function(el){el.textContent=q;});
    document.querySelectorAll(".dcart").forEach(function(a){a.setAttribute("aria-label","Cart, "+q+(q===1?" item":" items"));}); }
  function wireCheckout(){ document.querySelectorAll(".gcart__checkout").forEach(function(b){ b.setAttribute("href","/checkout"); }); }
  function refresh(){ return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json();})
      .then(function(c){ cart=c; if(window.GIX_CART&&window.GIX_CART.refresh) window.GIX_CART.refresh(); syncBadge(); wireCheckout(); return c; }).catch(function(){}); }
  function addLines(lines){ lines=(lines||[]).filter(function(l){return l.id&&l.quantity>0;});
    if(!lines.length){ openDrawer(); return; }
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:lines})})
      .then(function(r){return r.json();}).then(function(){return refresh();}).then(function(){openDrawer();}).catch(function(){}); }
  window.GIX_CART_SOURCE={
    items:function(){ return (cart.items||[]).map(function(l){ var nm=l.product_title||l.title||"Item"; if(l.variant_title&&l.variant_title.indexOf("Default")<0) nm+=" — "+l.variant_title; return {key:String(l.key),name:nm,price:money(l.final_price||l.price),unit:"",from:false,quote:false,qty:l.quantity}; }); },
    setQty:function(key,dd){ var line=(cart.items||[]).filter(function(l){return String(l.key)===String(key);})[0]; if(!line) return; return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:String(line.key),quantity:Math.max(0,line.quantity+dd)})}).then(function(r){return r.json();}).then(function(){return refresh();}).catch(function(){}); },
    remove:function(key){ var line=(cart.items||[]).filter(function(l){return String(l.key)===String(key);})[0]; if(!line) return; return fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:String(line.key),quantity:0})}).then(function(r){return r.json();}).then(function(){return refresh();}).catch(function(){}); }
  };
  function n(v){ return parseInt(v||"0",10)||0; }
  var lastFire=0;
  document.addEventListener("gd:checkout", function(ev){
    var d=ev.detail||{};
    var now=Date.now(); if(now-lastFire<4000) return;
    var t=n(d.tabletop), m=n(d.rack), ap=n(d.ap), sw=n(d.switches), fo=n(d.failover);
    var lvl=d.level, agreed=(d.agreed==="1"||d.agreed===1||d.agreed===true);
    if(!(t>0||m>0)) return;
    if(lvl!=="b"&&lvl!=="p"&&lvl!=="x") return;
    if(!agreed) return;
    lastFire=now;
    var lines=[];
    function pair(rentId,mgdMap,qty){ if(qty>0){ if(rentId) lines.push({id:+rentId,quantity:qty}); var mv=mgdMap&&mgdMap[lvl]; if(mv) lines.push({id:+mv,quantity:qty}); } }
    pair(RENT.tabletop,MGD.tabletop,t);
    pair(RENT.rack,MGD.rack,m);
    pair(RENT.ap,MGD.ap,ap);
    pair(RENT.sw,MGD.sw,sw);
    if(fo>0){ lines.push({id:+RENT.fo,quantity:fo}); lines.push({id:+FDATA,quantity:fo}); }
    addLines(lines);
  });
  document.addEventListener("click", function(e){
    if(!e.target.closest) return;
    var co=e.target.closest(".gcart__checkout"); if(co){ e.preventDefault(); location.href="/checkout"; return; }
    var cb=e.target.closest(".dcart, .mcart"); if(cb){ e.preventDefault(); openDrawer(); return; }
  }, true);
  document.addEventListener("c3q:lead", function(ev){
    var d=ev.detail||{}, L=d.lead||{}, q=d.quote||null, body=[];
    body.push("New Guard Depot quote request."); body.push("");
    Object.keys(L).forEach(function(k){ var v=L[k]; if(v!=null&&typeof v!=="object") body.push(k+": "+v); });
    if(q&&typeof q==="object"){ body.push(""); body.push("Quote:"); Object.keys(q).forEach(function(k){ var v=q[k]; if(v!=null&&typeof v!=="object") body.push("  "+k+": "+v); }); }
    if(d.quoteUrl){ body.push(""); body.push("Quote PDF: "+d.quoteUrl); }
    var fd=new URLSearchParams();
    fd.set("form_type","contact"); fd.set("utf8","\u2713");
    fd.set("contact[email]",L.email||L.repEmail||"");
    fd.set("contact[name]",L.name||L.company||"Quote request");
    if(L.phone) fd.set("contact[phone]",L.phone);
    fd.set("contact[body]",body.join("\n"));
    fetch("/contact",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded",Accept:"application/json"},body:fd.toString()}).catch(function(){});
  });
  function boot(){ refresh();
    var d=document.querySelector("[data-gix-cart]"); if(d&&window.MutationObserver){ new MutationObserver(function(){ wireCheckout(); syncBadge(); }).observe(d,{childList:true,subtree:true}); } }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();